// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
require('./_set-collection-from')('WeakMap');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es7.weak-map.from.js
// module id = 1012
// module chunks = 0